export const getDaysRemaining=(inputDate)=>{
    const msPerDay = 1000 * 60 * 60 * 24; // number of milliseconds in a day
    const currentDate = new Date(); // get the current date
    const inputYear = inputDate.slice(0, 4); // extract the year from the input date string
    const inputMonth = inputDate.slice(4, 6) - 1; // extract the month from the input date string (Note: month is 0-indexed in JavaScript)
    const inputDay = inputDate.slice(6); // extract the day from the input date string
    const inputTime = new Date(inputYear, inputMonth, inputDay).getTime(); // create a Date object for the input date and get the time value in milliseconds
    const timeRemaining = inputTime - currentDate.getTime(); // calculate the time remaining in milliseconds
    const daysRemaining = Math.ceil(timeRemaining / msPerDay); // calculate the number of days remaining and round up to the nearest integer
    return daysRemaining;
  }